import { Controller } from "stimulus"

// Handles the "select / unselect all" toggle for email attachment checkboxes.
// Expects one `toggle` master checkbox, one `label` element (text), one
// `counter` element (e.g. "2/3 selected"), and many `item` target checkboxes.
export default class extends Controller {
  static targets = ["toggle", "label", "counter", "item"]

  connect() {
    this.refresh()
  }

  toggleAll() {
    const checked = this.toggleTarget.checked
    this.selectableItems.forEach(item => { item.checked = checked })
    this.refresh()
  }

  refresh() {
    const items   = this.selectableItems
    const total   = items.length
    const checked = items.filter(item => item.checked).length
    const allOn   = total > 0 && checked === total

    this.toggleTarget.checked       = allOn
    this.toggleTarget.indeterminate = checked > 0 && !allOn

    if (this.hasLabelTarget) {
      this.labelTarget.textContent = allOn
        ? this.data.get("unselectLabel")
        : this.data.get("selectLabel")
    }

    if (this.hasCounterTarget) {
      this.counterTarget.textContent = this.data
        .get("counterTemplate")
        .replace("%{checked}", checked)
        .replace("%{total}",   total)
    }
  }

  // The e-invoicing picker disables what the regime will not carry, and the browser
  // never submits a disabled checkbox — so ticking or counting one promises the user a
  // document that will not travel.
  get selectableItems() {
    return this.itemTargets.filter(item => !item.disabled)
  }
}
